import { appConfig, makeAttached, pad } from "../../../utils";

import {
    createBasicGreenCard
} from "../JobCards/actions";

export const addOccurrence = ({ form, item, store }) => {
    form.setConfig({
        "title": "Add Occurrence",
        "type": "push",
        "location": `Database/Occurrences`,
        "fields": [{
            "label": "Number",
            "type": "value",
            value() {
                return `${appConfig.docPrefix}OCC-${pad(store.state.counts.occ.count)}`
            }
        }, {
            "label": "Title",
            "name": "Title",
            "type": "text",
        }, {
            "label": "Aircraft Code",
            "name": "Aircraft",
            "sortKey": "meta.Number",
            "type": "dropdown",
            "labelKey": "NameFull",
            "idKey": "ID",
            "dataLocation": "Database/AircraftCodes"
        }],
        async preSubmitHook({ data, db }) {
            const number = await db.utils.allocateCount("counts/occ/count");
            return {
                "Aircraft": makeAttached(data.Aircraft),
                "Number": `${appConfig.docPrefix}OCC-${pad(number)}`,
                "Reportable": false,
                "MOR": "N/A",
                "Open": true,
                "Date": {
                    "Created": (new Date()).toISOString()
                }
            }
        },
        async postSubmitHook({ db, newData }) {
            let greenCard = await createBasicGreenCard({ store, db, parent: newData });
            await db.set(`Database/Occurrences/${newData.ID}/JobCards`, greenCard.ID);
            await db.set(`Database/JobCards/${greenCard.ID}`, greenCard);
        }
    });
    form.getDropdownData();
    form.toggle();
};

export const editOccurrence = ({ form, pageItem }) => {
    form.setValues({...pageItem, "Aircraft": Object.keys(pageItem.Aircraft || {})});
    form.setConfig({
        "title": "Add Occurence",
        "type": "update",
        "location": `Database/Occurrences/${pageItem.ID}`,
        "fields": [{
            "label": "Title",
            "name": "Title",
            "type": "text",
        }, {
            "label": "Aircraft Code",
            "name": "Aircraft",
            "sortKey": "meta.Number",
            "type": "dropdown",
            "labelKey": "NameFull",
            "idKey": "ID",
            "dataLocation": "Database/AircraftCodes"
        }],
        preSubmitHook({ data }) {
            return {
                "Aircraft": makeAttached(data.Aircraft)
            }
        }
    });
    form.getDropdownData();
    form.toggle();
};

export const closeOccurrence = async ({ form, db, pageItem }) => {
    form.setConfig({
        "title": "Close Occurrence",
        "type": "update",
        "location": `Database/Occurrences/${pageItem.ID}`,
        "description": "Are you sure you want to close this occurrence?",
        "fields": [],
        preSubmitHook({ data }) {
            return {
                "Date": {
                    ...pageItem.Date,
                    "Closed": (new Date()).toISOString()
                },
                "Open": false
            }
        }
    });
    form.getDropdownData();
    form.toggle();
};

export const cancelOccurrence = async ({ form, db, pageItem }) => {
    form.setConfig({
        "title": "Cancel Occurrence",
        "type": "update",
        "location": `Database/Occurrences/${pageItem.ID}`,
        "description": "Are you sure you want to cancel this occurrence? This action cannot be undone.",    
        "fields": [],
        preSubmitHook({ data }) {
            return {
                "Date": {
                    ...pageItem.Date,
                    "Cancelled": (new Date()).toISOString()
                },
                "Open": false,
                "Reportable": false,
                "Cancelled": true,
            }
        }
    });
    form.getDropdownData();
    form.toggle();
}
